module.exports = __webpack_public_path__ + "img/close.b49bf3c6.svg";